// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loan-list {
  padding: 24px 25px;
}
.loan-list .top-container {
  box-sizing: content-box;
  width: 100%;
  margin-bottom: 33px;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
}
.loan-list .top-container .title {
  color: var(--800-grey, #404859);
  font-family: Inter;
  font-size: 32px;
  font-weight: 600;
  line-height: normal;
  display: flex;
  align-items: center;
  gap: 5px;
}
.loan-list .top-container .title span {
  cursor: pointer;
  color: var(--blue60, #5E8EB7);
  font-family: Inter;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-decoration-line: underline;
}
.loan-list .badges-container {
  display: flex;
}
.loan-list .loans-container {
  padding: 16px 0px;
}
.loan-list .loans-container > * {
  margin-bottom: 16px;
}
.loan-list .loans-container > *:last-child {
  margin-bottom: 0px;
}

.search-box {
  cursor: pointer;
  box-sizing: border-box;
  width: 384px;
  padding: 5px 18px 5px 8px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-radius: 10px;
  border: 1px solid var(--400-grey, #CCD3DB);
  background: var(--gray-100, #F9FAFB);
  color: var(--700-grey, #6E7889);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
}
.search-box > input {
  all: unset;
  width: 100%;
  margin-left: 8px;
}

.status-badge {
  cursor: pointer;
  width: -moz-fit-content;
  width: fit-content;
  padding: 4px 12px;
  border-radius: 100px;
  display: flex;
  align-items: center;
  background: var(--300-grey, #DFE4EB);
  height: 24px;
}
.status-badge:hover {
  background: #5E8EB7 !important;
}
.status-badge:hover .title {
  color: white !important;
}
.status-badge:hover .count {
  color: white !important;
}
.status-badge .title {
  margin-right: 4px;
  color: var(--800-grey, #404859);
  text-align: right;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px; /* 133.333% */
  white-space: nowrap;
}
.status-badge .count {
  color: var(--800-grey, #404859);
  text-align: right;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
}
.status-badge.selected {
  background: #355C7D;
}
.status-badge.selected .title, .status-badge.selected .count {
  color: #FFFFFF;
}
.status-badge.zero {
  pointer-events: none;
  color: #AFBDCC !important;
  opacity: 0.6;
  cursor: unset;
}

.loan-list-item {
  cursor: pointer;
  box-sizing: border-box;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 8px 24px 8px 16px;
  border-radius: 10px;
  border: 1px solid var(--600-grey, #929FB0);
  background: var(--white, #FFF);
}
.loan-list-item > * {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.loan-list-item > *.loan-status-badge-container {
  flex: 0.8 1;
}
.loan-list-item > *.borrower-summary-container {
  flex: 0.5 1;
}
.loan-list-item .loan-status-badge {
  display: inline-block;
  border-radius: 76px;
  border: 1px solid var(--blue60, #5E8EB7);
  padding: 4px 7px;
  color: var(--70, #48759A);
  text-align: center;
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.2px;
  text-transform: uppercase;
}
.loan-list-item .borrower-summary .caption {
  color: var(--700-grey, #6E7889);
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 115%;
  text-transform: capitalize;
  margin-bottom: 2px;
}
.loan-list-item .borrower-summary .borrower-name {
  color: var(--900-grey, #2A2F3C);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 115%;
  text-decoration-line: underline;
  text-transform: capitalize;
}
.loan-list-item .address-summary .caption {
  color: var(--700-grey, #6E7889);
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 115%;
  text-transform: capitalize;
  margin-bottom: 2px;
}
.loan-list-item .address-summary .address {
  color: var(--800-grey, #404859);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 115%;
  text-transform: capitalize;
  white-space: nowrap;
}
.loan-list-item .task-summary {
  padding-left: 10px;
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.loan-list-item .task-summary .caption {
  color: var(--700-grey, #6E7889);
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 115%;
  text-transform: capitalize;
  margin-bottom: 2.5px;
}
.loan-list-item .task-summary .task-item-container {
  display: flex;
  gap: 9px;
}
.loan-list-item .task-summary .task-item-container .task-item {
  box-sizing: border-box;
  height: 15px;
  width: 15px;
  border-radius: 100px;
  margin-right: 8px;
  background-color: #DFE4EB;
  border: 1.5px solid #CCD3DB;
}
.loan-list-item .task-summary .task-item-container .task-item.completed {
  background-color: #4CA852;
  border: unset;
}
.loan-list-item .task-summary .task-item-container .task-item.review {
  background-color: #855791;
  border: unset;
}
.loan-list-item .action-container {
  color: var(--blue60, #5E8EB7);
  text-align: right;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  white-space: nowrap;
  align-self: flex-end;
}
.loan-list-item:hover {
  border-radius: 10px;
  border: 1px solid var(--blue-40, #97BCF0);
  background: var(--10, #F5FAFF);
  box-shadow: 2px 2px 20px 0px rgba(11, 19, 26, 0.1);
}
.loan-list-item:hover .borrower-summary .caption {
  color: var(--70, #48759A);
}
.loan-list-item:hover .borrower-summary .borrower-name {
  color: var(--90, #244560);
}
.loan-list-item:hover .address-summary .caption {
  color: var(--70, #48759A);
}
.loan-list-item:hover .address-summary .address {
  color: var(--blue-80, #355C7D);
}
.loan-list-item:hover .task-summary .caption {
  color: var(--70, #48759A);
}
.loan-list-item:hover .action-container {
  color: var(--70, #48759A);
  font-weight: 600;
}
.loan-list-item:hover .action-container:hover {
  color: var(--90, #244560);
  font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/scenes/Private/LoanList/LoanList.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AACE;EACE,uBAAA;EACA,WAAA;EAEA,mBAAA;EAEA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,8BAAA;AADJ;AAGI;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AADN;AAGM;EACE,eAAA;EAEA,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,+BAAA;AAFR;AAOE;EACE,aAAA;AALJ;AAQE;EACE,iBAAA;AANJ;AAQI;EACE,mBAAA;AANN;AAOM;EACE,kBAAA;AALR;;AAWA;EACE,eAAA;EAEA,sBAAA;EACA,YAAA;EACA,yBAAA;EAEA,aAAA;EACA,mBAAA;EACA,2BAAA;EAEA,mBAAA;EACA,0CAAA;EACA,oCAAA;EAEA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAZF;AAcE;EACE,UAAA;EACA,WAAA;EACA,gBAAA;AAZJ;;AAgBA;EACE,eAAA;EACA,uBAAA;EAAA,kBAAA;EACA,iBAAA;EACA,oBAAA;EAEA,aAAA;EACA,mBAAA;EAEA,oCAAA;EACA,YAAA;AAfF;AAiBE;EACE,8BAAA;AAfJ;AAgBI;EACE,uBAAA;AAdN;AAgBI;EACE,uBAAA;AAdN;AAkBE;EACE,iBAAA;EAEA,+BAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EAEA,mBAAA;AAlBJ;AAqBE;EACE,+BAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;AAnBJ;AAsBE;EACE,mBAAA;AApBJ;AAqBI;EACE,cAAA;AAnBN;AAsBE;EACE,oBAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;AApBJ;;AAwBA;EACE,eAAA;EAEA,sBAAA;EACA,WAAA;EAEA,aAAA;EACA,mBAAA;EAGA,0BAAA;EAEA,mBAAA;EACA,0CAAA;EACA,8BAAA;AA1BF;AA4BE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;AA1BJ;AA4BI;EACE,WAAA;AA1BN;AA6BI;EACE,WAAA;AA3BN;AA+BE;EACE,qBAAA;EAEA,mBAAA;EACA,wCAAA;EAEA,gBAAA;EAEA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;AAhCJ;AAoCI;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;EAEA,kBAAA;AAnCN;AAsCI;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,+BAAA;EACA,0BAAA;AApCN;AAyCI;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;EAEA,kBAAA;AAxCN;AA2CI;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;EAEA,mBAAA;AA1CN;AA8CE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AA5CJ;AA8CI;EACE,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;EAEA,oBAAA;AA7CN;AAgDI;EACE,aAAA;EACA,QAAA;AA9CN;AAgDM;EACE,sBAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;EAEA,iBAAA;EAEA,yBAAA;EACA,2BAAA;AAhDR;AAkDQ;EACE,yBAAA;EACA,aAAA;AAhDV;AAmDQ;EACE,yBAAA;EACA,aAAA;AAjDV;AAuDE;EACE,6BAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EAEA,mBAAA;EAEA,oBAAA;AAvDJ;AA0DE;EACE,mBAAA;EACA,yCAAA;EACA,8BAAA;EACA,kDAAA;AAxDJ;AA2DM;EACE,yBAAA;AAzDR;AA2DM;EACE,yBAAA;AAzDR;AA8DM;EACE,yBAAA;AA5DR;AA8DM;EACE,8BAAA;AA5DR;AAiEM;EACE,yBAAA;AA/DR;AAmEI;EACE,yBAAA;EACA,gBAAA;AAjEN;AAmEM;EACE,yBAAA;EACA,gBAAA;AAjER","sourcesContent":[".loan-list {\n  padding: 24px 25px;\n\n  .top-container {\n    box-sizing: content-box;\n    width: 100%;\n\n    margin-bottom: 33px;\n\n    display: flex;\n    flex-direction: row;\n    align-items: flex-end;\n    justify-content: space-between;\n\n    .title {\n      color: var(--800-grey, #404859);\n      font-family: Inter;\n      font-size: 32px;\n      font-weight: 600;\n      line-height: normal;\n      display: flex;\n      align-items: center;\n      gap: 5px;\n\n      span {\n        cursor: pointer;\n\n        color: var(--blue60, #5E8EB7);\n        font-family: Inter;\n        font-size: 32px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: normal;\n        text-decoration-line: underline;\n      }\n    }\n  }\n\n  .badges-container {\n    display: flex;\n  }\n\n  .loans-container {\n    padding: 16px 0px;\n\n    >* {\n      margin-bottom: 16px;\n      &:last-child {\n        margin-bottom: 0px;\n      }\n    }\n  }\n}\n\n.search-box {\n  cursor: pointer;\n\n  box-sizing: border-box;\n  width: 384px;\n  padding: 5px 18px 5px 8px;\n\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n\n  border-radius: 10px;\n  border: 1px solid var(--400-grey, #CCD3DB);\n  background: var(--gray-100, #F9FAFB);\n\n  color: var(--700-grey, #6E7889);\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 120%;\n\n  >input {\n    all: unset;\n    width: 100%;\n    margin-left: 8px;\n  }\n}\n\n.status-badge {\n  cursor: pointer;\n  width: fit-content;\n  padding: 4px 12px;\n  border-radius: 100px;\n\n  display: flex;\n  align-items: center;\n\n  background: var(--300-grey, #DFE4EB);\n  height: 24px;\n\n  &:hover {\n    background: #5E8EB7 !important;\n    .title {\n      color: white !important;\n    }\n    .count {\n      color: white !important;\n    }\n  }\n\n  .title {\n    margin-right: 4px;\n\n    color: var(--800-grey, #404859);\n    text-align: right;\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 16px; /* 133.333% */\n\n    white-space: nowrap;\n  }\n\n  .count {\n    color: var(--800-grey, #404859);\n    text-align: right;\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 16px; /* 133.333% */\n  }\n\n  &.selected {\n    background: #355C7D;\n    .title, .count {\n      color: #FFFFFF;\n    }\n  }\n  &.zero {\n    pointer-events: none;\n    color: #AFBDCC !important;\n    opacity: 0.6;\n    cursor: unset;\n  }\n}\n\n.loan-list-item {\n  cursor: pointer;\n\n  box-sizing: border-box;\n  width: 100%;\n\n  display: flex;\n  align-items: center;\n\n\n  padding: 8px 24px 8px 16px;\n\n  border-radius: 10px;\n  border: 1px solid var(--600-grey, #929FB0);\n  background: var(--white, #FFF);\n\n  >* {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n\n    &.loan-status-badge-container {\n      flex: 0.8\n    }\n    \n    &.borrower-summary-container {\n      flex: 0.5;\n    }\n  }\n\n  .loan-status-badge {\n    display: inline-block;\n\n    border-radius: 76px;\n    border: 1px solid var(--blue60, #5E8EB7);\n\n    padding: 4px 7px;\n\n    color: var(--70, #48759A);\n    text-align: center;\n    font-family: Inter;\n    font-size: 10px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    letter-spacing: 0.2px;\n    text-transform: uppercase;\n  }\n\n  .borrower-summary {\n    .caption {\n      color: var(--700-grey, #6E7889);\n      font-family: Inter;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 115%;\n      text-transform: capitalize;\n\n      margin-bottom: 2px;\n    }\n\n    .borrower-name {\n      color: var(--900-grey, #2A2F3C);\n      font-family: Inter;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 115%;\n      text-decoration-line: underline;\n      text-transform: capitalize;\n    }\n  }\n\n  .address-summary {\n    .caption {\n      color: var(--700-grey, #6E7889);\n      font-family: Inter;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 115%;\n      text-transform: capitalize;\n\n      margin-bottom: 2px;\n    }\n\n    .address {\n      color: var(--800-grey, #404859);\n      font-family: Inter;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 115%;\n      text-transform: capitalize;\n\n      white-space: nowrap;\n    }\n  }\n\n  .task-summary {\n    padding-left: 10px;\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n\n    .caption {\n      color: var(--700-grey, #6E7889);\n      font-family: Inter;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 115%;\n      text-transform: capitalize;\n\n      margin-bottom: 2.5px;\n    }\n\n    .task-item-container {\n      display: flex;\n      gap: 9px;\n\n      .task-item {\n        box-sizing: border-box;\n        height: 15px;\n        width: 15px;\n        border-radius: 100px;\n        \n        margin-right: 8px;\n\n        background-color: #DFE4EB;\n        border: 1.5px solid #CCD3DB;\n\n        &.completed {\n          background-color: #4CA852;\n          border: unset;\n        }\n\n        &.review {\n          background-color: #855791;\n          border: unset;\n        }\n      }\n    }\n  }\n\n  .action-container {\n    color: var(--blue60, #5E8EB7);\n    text-align: right;\n    font-family: Inter;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n\n    white-space: nowrap;\n\n    align-self: flex-end;\n  }\n\n  &:hover {\n    border-radius: 10px;\n    border: 1px solid var(--blue-40, #97BCF0);\n    background: var(--10, #F5FAFF);\n    box-shadow: 2px 2px 20px 0px rgba(11, 19, 26, 0.10);\n\n    .borrower-summary {\n      .caption {\n        color: var(--70, #48759A);\n      }\n      .borrower-name {\n        color: var(--90, #244560);\n      }\n    }\n\n    .address-summary {\n      .caption {\n        color: var(--70, #48759A);\n      }\n      .address {\n        color: var(--blue-80, #355C7D);\n      }\n    }\n\n    .task-summary {\n      .caption {\n        color: var(--70, #48759A);\n      }\n    }\n\n    .action-container {\n      color: var(--70, #48759A);\n      font-weight: 600;\n\n      &:hover {\n        color: var(--90, #244560);\n        font-weight: 700;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
